import axios from 'axios';
import keys from '../../../API_MOCKS/v2-beta/profile/keys/index.json';
import Log from '../../utils/Debug';

const API_URL = process.env.API_URL; // eslint-disable-line

export default (bottle) => {
  bottle.constant('keyManagerServicesURI', `${API_URL}/profile/keys`);

  bottle.constant('keyManagerSpecData', keys);

  bottle.factory(
    'keyManagerFetchKeys',
    ({
      keyManagerServicesURI,
    }) => (token, testUrl, headers) => {
      Log.info('....keyManagerFetchKeys....', token, testUrl, headers);
      if (!token) {
        Log.error(token, 'Service: keyManagerFetchKeys Missing Token');
      }
      const options = headers || {
        headers: {
          authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          'cache-control': 'no-cache',
        },
      };
      axios.interceptors.request.use((request) => {
        Log.info('Starting Request', request);
        return request;
      });
      axios.interceptors.response.use((response) => {
        Log.info('Response:', response);
        return response;
      });
      // return Promise.resolve({ data: keys });
      const url = testUrl || keyManagerServicesURI;
      try {
        return axios.get(url, options);
      } catch (e) {
        return Log.error(e);
      }
    },
  );

  bottle.factory(
    'keyManagerCreateKey',
    ({
      keyManagerServicesURI,
    }) => (token, testUrl, data = {}) => {
      Log.info('....keyManagerCreateKey....', token, testUrl, data);
      if (!token) {
        Log.error(token, '!!!! keyManagerCreateKey Missing Token');
      }
      const options = {
        headers: {
          authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          'cache-control': 'no-cache',
        },
      };
      axios.interceptors.request.use((request) => {
        Log.info('Starting Request', request);
        return request;
      });
      axios.interceptors.response.use((response) => {
        Log.info('Response:', response);
        return response;
      });
      return axios.post(keyManagerServicesURI, data, options);
    },
  );
};
